module.exports = __webpack_public_path__ + "img/ico_producto.4cbf83aa.svg";